import { HOC } from 'src/shared/componentBuilder';
import { MouseEventHandler, createElement } from 'react';
import { omit } from 'lodash';
import { OrderNannyParams } from './orderNanny/types';
import { useOrderNanny } from './useOrderNanny';

interface OrderNannyProps extends OrderNannyParams {
  catalogItemId: number;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
}

const arrOfInternalKeys: Array<keyof OrderNannyProps> = ['catalogItemId', 'initiatorId', 'dialogId'];

export const withOrderNannyClick: HOC<OrderNannyProps> = (component) => (props) => {
  const [orderFeature, isLoading] = useOrderNanny();
  const onClick: MouseEventHandler<HTMLElement> = async (event) =>
    orderFeature(props.catalogItemId, props).then((res) => res.tap(() => props.onClick?.(event)));

  return createElement(component, { ...omit(props, ...arrOfInternalKeys), onClick, disabled: isLoading || props.disabled });
};
